package com.essntl.features.area.ui.allareas.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AreaItem(
    area: AreaModel,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
            .height(40.dp)
            .border(
                width = 1.dp,
                color = with(MaterialTheme.esColorScheme) {
                    borderPrimary
                },
                shape = CircleShape,
            )
            .clip(CircleShape)
            .background(
                with(MaterialTheme.esColorScheme) {
                    bgSecondary
                },
            )
            .padding(horizontal = 2.spacing),
    ) {
        Text(
            text = area.name.orEmpty(),
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p1Regular16,
        )
    }
}